import { useContext, useState } from 'react';
import ModalComponent from 'components/Common/Modal';
import { store } from 'components/Store';
import useGeneralApiCall from 'components/Dashboard/apiCalls/useGeneralApiCall';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import thousandCommas from 'components/Dashboard/helpers/thousandCommas';

const RemoveInteractionsModal = ({ openState, interactions, onSuccess }) => {
  const { isOpen, setIsOpen } = openState ?? {};
  const [isDeleting, setIsDeleting] = useState(false);
  const { generalApiCall } = useGeneralApiCall();
  const { dispatch } = useContext(store);

  const count = interactions?.length ?? 0;
  const interactionsText = count === 1 ? 'this interaction' : `these ${thousandCommas(count)} interactions`;

  const handleDelete = async () => {
    setIsDeleting(true);
    // The delete endpoint responds 200 with an empty body, so `result` (response.data) would be
    // an empty, falsy string — request the full response and check the status instead.
    const response = await generalApiCall({
      method: 'post',
      pathname: '/api/crm-interaction/delete',
      requestProperties: interactions?.map((item) => item.id),
      needsAuthentication: true,
      returnCompleteRequest: true,
    });
    setIsDeleting(false);
    if (response?.status === 200) {
      createNotification('success', `Interaction${count === 1 ? '' : 's'} deleted successfully`);
      onSuccess?.();
      // The interactions list page owns its own local state and doesn't know this delete
      // happened - reuse the same "list needs a refetch" signal it already listens for after
      // logging a new interaction.
      dispatch({ type: 'MODIFY_SECTION', parameter: 'interactionLogged', value: true });
      setIsOpen(false);
    }
  };

  return (
    <ModalComponent
      maxWidth={480}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      overlayClassName='react-modal-overlay adjustment-of-position'
    >
      <div className='p-4 px-lg-5 pt-5 pb-lg-2'>
        <div className='text-center'>
          <p>Are you sure you want to delete {interactionsText}?</p>
          <div className='my-4'>
            <button
              className='general-button outline-button general-button-spacing mr-2 mr-lg-3 rounded-pill'
              onClick={() => setIsOpen(false)}
              disabled={isDeleting}
            >
              Cancel
            </button>
            <button
              className={`general-button general-button-spacing delete-note-button ${isDeleting ? '' : 'text-white'} rounded-pill`}
              onClick={handleDelete}
              disabled={isDeleting}
            >
              {isDeleting ? 'Deleting...' : count === 1 ? 'Delete interaction' : `Delete ${thousandCommas(count)} interactions`}
            </button>
          </div>
        </div>
      </div>
    </ModalComponent>
  );
};

export default RemoveInteractionsModal;
